import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Identification.css";
import GovHeader from "../../shared/components/GovHeader/GovHeader";
import Spinner from "react-bootstrap/Spinner";
import { useManualAuth } from "../auth/ManualAuthProvider";
import { users, UserData } from "../../shared/data/usersData";
import SessionCountdown from "../session/components/SessionCountdown";
import useSessionTimer from "../session/hooks/useSessionTimer";
import { logger } from "../../shared/utils/logger.client";
import { useTranslation } from "react-i18next";

const Identification: React.FC = () => {
  const [firstName, setFirstName] = useState("XXXPEDRO");
  const [lastName, setLastName] = useState("XXXODWYER");
  const [email, setEmail] = useState("oot.seu@gmail.com");
  const [PublicServiceNumber, setPublicServiceNumber] = useState("IE/IE/1050266G");
  const [BirthDate, setBirthDate] = useState("1941-08-27");
  const [selectedUserIndex, setSelectedUserIndex] = useState<number | "">("");

  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useManualAuth();
  const { startTimer } = useSessionTimer();
  const { t } = useTranslation();

  const applyUser = (idx: number) => {
    const user = users[idx];
    setFirstName(user.firstName);
    setLastName(user.lastName);
    setEmail(user.email);
    setPublicServiceNumber(user.PublicServiceNumber);
    setBirthDate(user.BirthDate);
  };

  const handleSelectUser = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    if (val === "") {
      setSelectedUserIndex("");
      setFirstName("");
      setLastName("");
      setEmail("");
      setPublicServiceNumber("");
      setBirthDate("");
      return;
    }
    const idx = parseInt(val, 10);
    setSelectedUserIndex(idx);
    applyUser(idx);
  };

  const handleSubmit = async () => {
    if (!firstName || !lastName || !PublicServiceNumber || !BirthDate) {
      setError(t("identification.error.requiredFields"));
      return;
    }
    if (new Date(BirthDate) >= new Date()) {
      setError(t("identification.error.birthDatePast"));
      return;
    }
    const userPayload = {
      firstName,
      lastName,
      PublicServiceNumber,
      BirthDate,
      email,
    };

    try {
      setSubmitting(true);
      await login(userPayload);
      await startTimer();
      navigate("/preview", { replace: true });
    } catch (err) {
      logger.error("Login failed:", err);
      navigate("/error", {
        state: { errorCode: "500", errorMessage: t("identification.error.loginFailed") },
        replace: true,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => navigate("/login");

  return (
      <div>
        <SessionCountdown />
        <main className="form-wrapper">
          <div className="form-area" id="BOX_FORM_AREA">
            <fieldset className="personal-info-box" id="BOX_IDENTIFICATION">
              <legend>{t("identification.legend")}</legend>
              <div className="form-group">
                <label htmlFor="SEL_USER">{t("identification.selectTestUser")}</label>
                <select
                    id="SEL_USER"
                    className="form-input"
                    value={selectedUserIndex}
                    onChange={handleSelectUser}
                >
                  <option value="">{t("identification.chooseUser")}</option>
                  {users.map((user, idx) => (
                      <option key={idx} value={idx}>
                        {user.firstName} ({user.BirthDate})
                      </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="TXT_FIRSTNAME">{t("identification.firstName")}</label>
                <input
                    id="TXT_FIRSTNAME"
                    type="text"
                    className="form-input"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="TXT_LASTNAME">{t("identification.lastName")}</label>
                <input
                    id="TXT_LASTNAME"
                    type="text"
                    className="form-input"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="TXT_EMAIL">{t("identification.emailOptional")}</label>
                <input
                    id="TXT_EMAIL"
                    type="email"
                    className="form-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="TXT_PUBLICSERVICENUMBER">{t("identification.uniqueIdentifier")}</label>
                <input
                    id="TXT_PPSN"
                    type="text"
                    className="form-input"
                    placeholder={t("identification.uniqueIdentifierPlaceholder")}
                    value={PublicServiceNumber}
                    onChange={(e) => setPublicServiceNumber(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label htmlFor="TXT_BIRTHDATE">{t("identification.dateOfBirth")}</label>
                <input
                    id="CAL_BIRTHDATE"
                    type="date"
                    className="form-input"
                    value={BirthDate}
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) => setBirthDate(e.target.value)}
                />
              </div>

              {error && <div className="error-text" id="TXT_ERROR">{error}</div>}
            </fieldset>

            <div className="buttonContainer">
              <button className="cancelButton" id="BTN_CANCEL" onClick={handleCancel} disabled={submitting}>
                {t("identification.back")}
              </button>
              <button className="selectButton" id="BTN_CONTINUE" onClick={handleSubmit} disabled={submitting}>
                {submitting ? t("identification.loading") : t("identification.continue")}
              </button>
            </div>
          </div>
        </main>
      </div>
  );
};

export default Identification;
